/* Koalla — Spiel-FAQ
   Baut die Themen-Leiste aus allen FAQ-Gruppen der Seite, filtert die Fragen
   per Stichwort und klappt eine Frage auf, auf die ein Direktlink (#f9) zeigt.
   Geladen mit defer aus sections/koalla-faq-header.liquid. */
(() => {
  const qsa = (sel, root = document) => Array.from(root.querySelectorAll(sel));
  const norm = (s) => s.toLocaleLowerCase('de').replace(/\s+/g, ' ').trim();

  let items = [];
  const openedBySearch = new Set();

  function buildNav() {
    const nav = document.querySelector('[data-kfq-nav]');
    if (!nav) return;
    const groups = qsa('[data-kfq-group]');
    nav.querySelector('[data-kfq-nav-list]').replaceChildren(
      ...groups.map((group) => {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.href = `#${group.id}`;
        a.textContent = group.dataset.kfqLabel;
        li.append(a);
        return li;
      })
    );
    nav.hidden = groups.length < 2;
  }

  function indexItems() {
    items = qsa('[data-kfq-item]').map((item) => ({
      item,
      text: norm(
        `${item.querySelector('summary').textContent} ${item.querySelector('[data-kfq-answer]')?.textContent ?? ''}`
      ),
    }));
  }

  function setStatus(count, query) {
    const status = document.querySelector('[data-kfq-status]');
    if (!status) return;
    status.replaceChildren();
    if (!query) return;
    if (count) {
      status.textContent = `${count} ${count === 1 ? 'Frage' : 'Fragen'} gefunden`;
      return;
    }
    status.append('Dazu haben wir noch keine Antwort. ');
    const contact = document.querySelector('[data-kfq-contact]');
    if (contact) {
      const a = document.createElement('a');
      a.href = `#${contact.id}`;
      a.textContent = 'Stellt uns eure Frage';
      status.append(a);
    }
  }

  function filter(query) {
    const terms = norm(query).split(' ').filter(Boolean);
    openedBySearch.forEach((item) => { item.open = false; });
    openedBySearch.clear();

    const hits = [];
    items.forEach(({ item, text }) => {
      const match = terms.every((t) => text.includes(t));
      item.hidden = !match;
      if (match) hits.push(item);
    });
    qsa('[data-kfq-group]').forEach((group) => {
      group.hidden = terms.length > 0 && !group.querySelector('[data-kfq-item]:not([hidden])');
      const chip = document.querySelector(`[data-kfq-nav-list] a[href="#${CSS.escape(group.id)}"]`);
      if (chip) chip.parentElement.hidden = group.hidden;
    });
    document.documentElement.classList.toggle('kfq-searching', terms.length > 0);

    // Bei wenigen Treffern aufklappen — sonst sieht man nicht, ob das Wort in der Antwort steht
    if (terms.length && hits.length <= 5) {
      hits.forEach((item) => {
        if (!item.open) {
          item.open = true;
          openedBySearch.add(item);
        }
      });
    }
    setStatus(hits.length, terms.length);
  }

  function openFromHash() {
    const id = decodeURIComponent(location.hash.slice(1));
    const item = id && document.getElementById(id);
    if (!item || !item.matches('[data-kfq-item]')) return;
    const input = document.querySelector('[data-kfq-search]');
    if (input && input.value) {
      input.value = '';
      filter('');
    }
    item.open = true;
    item.scrollIntoView({ block: 'start' });
  }

  function init() {
    buildNav();
    indexItems();

    const search = document.querySelector('[data-kfq-search-wrap]');
    const input = document.querySelector('[data-kfq-search]');
    if (search && input && !input.dataset.kfqBound) {
      input.dataset.kfqBound = 'true';
      search.hidden = false;
      input.addEventListener('input', () => filter(input.value));
    }
    if (input && input.value) filter(input.value);
  }

  init();
  openFromHash();
  window.addEventListener('hashchange', openFromHash);

  // Theme-Editor: Sektionen kommen und gehen, ausgewählte Fragen aufklappen
  ['shopify:section:load', 'shopify:section:unload', 'shopify:section:reorder'].forEach((type) =>
    document.addEventListener(type, () => requestAnimationFrame(init))
  );
  document.addEventListener('shopify:block:select', (event) => {
    if (event.target.matches?.('[data-kfq-item]')) event.target.open = true;
  });
})();
